import React from 'react';
import '../less/main.less';

export default function template() {
    const { children, display, classNames } = this.props;

    return (
        <div ref={this.tooltipRef} className={`tooltip-block ${classNames}`} style={{
            display: display,
            top: this.state.tooltipTop,
            left: this.state.tooltipLeft,
            minWidth: this.state.tooltipWinWidth,
            marginRight: this.state.tooltipMarginRight}}>
            <div className="tooltip-block-square" style={{ left: this.state.arrowLeft }}/>
          {children}
        </div>
    );
}
